module.exports = __webpack_public_path__ + "static/img/btn_line_contact2.df6de77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/btn_line_contact2.png
// module id = 8UTP
// module chunks = 134